import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Cannabis Prague · Elevate Your Understanding</p>
        <h1>Stay Informed on Cannabis Policy and Culture in Prague</h1>
        <p className="lede">
          Dive into our comprehensive coverage of local cannabis laws, policy updates, and educational resources. Join us in exploring the evolving landscape of cannabis culture in Prague.
        </p>
        <div className="cta-row">
          <a href="/news" target="_blank">
            Read the Latest News
          </a>
          <a href="/learn" target="_blank" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated with the latest changes in cannabis legislation and regulations affecting the Prague area.
          </p>
        </article>
        <article>
          <h2>Legal Status Information</h2>
          <p>
            Understand the current legal status of cannabis in Prague, including rights and responsibilities for consumers and advocates.
          </p>
        </article>
        <article>
          <h2>Educational Insights</h2>
          <p>
            Access a wealth of information about cannabis culture, its benefits, and responsible usage through our curated educational content.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;
